import "./style.css";
import WorkoutDetails from "../../common/WorkoutDetails/WorkoutDetails.js";
import BigDaddyFitnessHeader from "./BigDaddyFitnessHeader.js";

import jsonDataEn from "./data-en.json";
import jsonDataFr from "./data-fr.json";
import { useContext } from "react";
import LanguageContext from "../../../context/LanguageContext";

const BigDaddyFitnessWorkoutDetails = () => {
  const { language } = useContext(LanguageContext);
  const data = language === "en" ? jsonDataEn.data : jsonDataFr.data;
  return (
    <div className="bigdaddyfitness">
      <BigDaddyFitnessHeader />
      <WorkoutDetails footer={data.footerTextLine1} />
    </div>
  );
};

export default BigDaddyFitnessWorkoutDetails;
